import React, {useEffect} from 'react';
import {View} from 'react-native';
import {useSelector, useDispatch} from 'react-redux';
import ClaimWallScreen from './ClaimWallScreen';
import PutWallScanHome from './PutWallScanHome';
import NoticeToast from './NoticeToast';
import PutWallDialogs from './PutWallDialogs';
import PutWallPostScanPrompt from './PutWallPostScanPrompt';
import {usePostScanResume} from '../postScanning/usePostScanResume';
import {resetProductFirst, resumePostScan} from '../../actions/productFirstActions';
import {selectProductFirstToteSet} from '../../selectors/productFirstSelectors';

const PutWall = () => {
  const dispatch = useDispatch();
  const toteSet = useSelector(selectProductFirstToteSet);

  useEffect(() => {
    return () => dispatch(resetProductFirst());
  }, []);

  usePostScanResume(({postScanningModulesRemaining}) => {
    dispatch(resumePostScan(postScanningModulesRemaining));
    return true;
  }, ['postScanningModulesRemaining']);

  return (
    <View style={{flex: 1}}>
      {toteSet ? <PutWallScanHome /> : <ClaimWallScreen />}
      <PutWallDialogs />
      <PutWallPostScanPrompt />
      <NoticeToast />
    </View>
  );
};

export default PutWall;
